export default "__VITE_ASSET__CyVNy4oa__"